module.exports = {"370406001":"山城街道","370406101":"店子镇","370406102":"西集镇","370406103":"桑村镇","370406104":"北庄镇","370406105":"城头镇","370406106":"徐庄镇","370406107":"水泉镇","370406108":"冯卯镇","370406109":"凫城镇","370406405":"山亭经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370406.json
// module id = 1505
// module chunks = 0